<lcs-loading-overlay [show]="callState | lcsCallState : 'loading'">
  <div mat-dialog-title class="dialog-header">
    <h3 class="dialog-title">{{ title }}</h3>
    <button type="button" mat-icon-button tabindex="-1" (click)="onCloseClick()"><mat-icon>close</mat-icon></button>
  </div>
  <form [formGroup]="form" (ngSubmit)="onCreate()">
    <mat-dialog-content>
      <div class="advanced-dialog-content">
        <mat-form-field class="flex-half">
          <mat-label>Start Date *</mat-label>
          <input
            matInput
            autocomplete="off"
            lcsDatepicker
            formControlName="activeStartDate"
            [lcsDatepickerPanel]="activeStartDatePanel"
            required
            />
            <lcs-datepicker-toggle matSuffix [for]="activeStartDatePanel"></lcs-datepicker-toggle>
            <lcs-datepicker-panel #activeStartDatePanel></lcs-datepicker-panel>
            @if (form.get('activeStartDate')?.hasError('required')) {
              <mat-error>
                Start Date is Required.
              </mat-error>
            }
          </mat-form-field>
          <mat-form-field class="flex-half">
            <mat-label>End Date</mat-label>
            <input
              matInput
              autocomplete="off"
              lcsDatepicker
              formControlName="activeEndDate"
              [lcsDatepickerPanel]="activeEndDatePanel"
              />
              <lcs-datepicker-toggle matSuffix [for]="activeEndDatePanel"></lcs-datepicker-toggle>
              <lcs-datepicker-panel #activeEndDatePanel></lcs-datepicker-panel> </mat-form-field
            ></div>
          </mat-dialog-content>
          <mat-dialog-actions>
            <button type="submit" title="Confirm" mat-raised-button>OK</button>
            <button type="button" title="Cancel" mat-stroked-button (click)="onCloseClick()">Cancel</button>
          </mat-dialog-actions>
        </form>
      </lcs-loading-overlay>
